export const SET_REVIEW_QUEUE_AUTHOR_FILTERS = 'SET_REVIEW_QUEUE_AUTHOR_FILTERS'
export const SET_REVIEW_QUEUE_KEYWORD_FILTER = 'SET_REVIEW_QUEUE_KEYWORD_FILTER'
export const SET_REVIEW_QUEUE_DRAFT_FILTER = 'SET_REVIEW_QUEUE_DRAFT_FILTER'
export const SET_REVIEW_QUEUE_COURSE_FILTER = 'SET_REVIEW_QUEUE_COURSE_FILTER'
export const SET_REVIEW_QUEUE_LEVELS_FILTER = 'SET_REVIEW_QUEUE_LEVELS_FILTER'
export const SET_REVIEW_QUEUE_SORT_TYPE = 'SET_REVIEW_QUEUE_SORT_TYPE'
export const SET_REVIEW_QUEUE_SORT_ORDER = 'SET_REVIEW_QUEUE_SORT_ORDER'
export const SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW =
  'SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW'
export const SET_REVIEW_QUEUE_NEED_FINAL_REVIEW =
  'SET_REVIEW_QUEUE_NEED_FINAL_REVIEW'
export const SET_REVIEW_QUEUE_ALL_REVIEWS = 'SET_REVIEW_QUEUE_ALL_REVIEWS'
export const CLEAR_REVIEW_QUEUE_FILTERS = 'CLEAR_REVIEW_QUEUE_FILTERS'
export const SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS =
  'SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS'

export function setAuthorsFilter(authorIds) {
  return {
    type: SET_REVIEW_QUEUE_AUTHOR_FILTERS,
    authors_id_in: authorIds
  }
}

export function setKeywordFilter(keyword) {
  return {
    type: SET_REVIEW_QUEUE_KEYWORD_FILTER,
    name_or_description_cont: keyword
  }
}

export function setCourseFilter(courseId) {
  return {
    type: SET_REVIEW_QUEUE_COURSE_FILTER,
    mock_course_id_in: courseId
  }
}

export function setLevelFilter(levels) {
  return {
    type: SET_REVIEW_QUEUE_LEVELS_FILTER,
    mock_level_id_in: levels
  }
}

export function setReviewQueueSortType(sort) {
  return {
    type: SET_REVIEW_QUEUE_SORT_TYPE,
    sort
  }
}

export function setReviewQueueSortOrder(order) {
  return {
    type: SET_REVIEW_QUEUE_SORT_ORDER,
    order
  }
}

export function setNeedStandardsFilter() {
  return {
    type: SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW
  }
}

export function setNeedFinalFilter() {
  return {
    type: SET_REVIEW_QUEUE_NEED_FINAL_REVIEW
  }
}

export function setAllReviewsFilter() {
  return {
    type: SET_REVIEW_QUEUE_ALL_REVIEWS
  }
}

export function clearReviewQueueFilters() {
  return {
    type: CLEAR_REVIEW_QUEUE_FILTERS
  }
}

export function setTargetGradeLevelFilter(gradeLevels) {
  return {
    type: SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS,
    grade_levels_id_in: gradeLevels
  }
}



// WEBPACK FOOTER //
// ./src/actions/reviewqueuefilters.js